<template>
  <div class="paginnation" :style="getStyle()">
    <div class="prev" :class="{ active: currentPage == 1 }" @click="currentEvent(false)"><i class="el-icon-d-arrow-left"></i><span>{{ $t('public.lastPage') }}</span></div>
    <div class="current m-l-20">{{ currentPage }}</div>
    <div class="m-l-8 m-r-8">/</div>
    <div class="total m-r-20">{{ totalPage }}</div>
    <div class="next" :class="{ active: currentPage == totalPage }" @click="currentEvent(true)"><span>{{ $t('public.nextPage') }}</span><i class="el-icon-d-arrow-right"></i></div>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    productList: {
      type: Array,
      default: () => []
    },
    pageSize: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      currentPageData: [],
      currentPage: 1,
      totalPage: 1
    }
  },
  watch: {
    productList: {
      handler(newV, oldV) {
        this.currentPage = 1
        this.updateHandle()
      },
      deep: true
    }
  },
  mounted() {
    this.updateHandle()
  },
  methods: {
    getStyle() {
      if (this.$route.path === '/overview/detail') {
        return 'margin-top:10px'
      } else {
        return 'margin-top:20px'
      }
    },
    updateHandle() {
      this.totalPage = Math.ceil(this.productList.length / this.pageSize)
      this.totalPage = this.totalPage === 0 ? 1 : this.totalPage
      this.setCurrentPageData()
    },
    setCurrentPageData() {
      const begin = (this.currentPage - 1) * this.pageSize
      const end = this.currentPage * this.pageSize
      this.currentPageData = this.productList.slice(begin, end)
    },
    currentEvent(val) {
      if (val) {
        if (this.currentPage === this.totalPage) return
        this.currentPage++
        this.setCurrentPageData()
        const { currentPageData } = this
        this.$emit('emitter', currentPageData)
      } else {
        if (this.currentPage === 1) return
        this.currentPage--
        this.setCurrentPageData()
        const { currentPageData } = this
        this.$emit('emitter', currentPageData)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.paginnation {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: #666;
  .el-icon-d-arrow-left {
    margin-right: 5px;
  }
  .el-icon-d-arrow-right {
    margin-left: 5px;
  }
  .prev, .next {
    font-size: 12px;
    border: 1px solid $subjectColor;
    border-radius: 4px;
    cursor: pointer;
    color: $subjectColor;
  }
  .prev {
    padding: 6px 12px 4px 8px;
  }
  .next {
    padding: 6px 8px 4px 12px;
  }
  .active {
    color: #c0c4cc;
    border-color: #c0c4cc;;
  }
}
</style>
